import React from "react"
import { Route } from "react-router-dom"

/**
 * Default route to be replaced with a loading indicator
 */
export const LoadingGuardRoute = () => <Route render={() => null} />
